import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { ICorporatePartner } from '../../corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../../corporate-partner/corporate-partner.method';
import { BookParameters } from '../../model/bookparameter.model';
import { RecentSearch } from '../../model/recent-search.model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { NavigationBookComponent } from '../navigation-book/navigation-book.component';
import { SwitchingAccountService } from '../switching-account/switching-account.service';

declare let delta: any;

@Component({
  selector: 'ngc-mobile-widget-modal',
  templateUrl: './mobile-widget-modal.component.html',
  animations: [
    trigger('navigation', [
      state('true', style({ left: '-100%', display: 'none' })),
      state('false', style({ left: '0%', display: 'block' })),
      transition('0 => 1', animate('.4s')),
      transition('1 => 0', animate('.4s'))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MobileWidgetModalComponent implements OnInit, OnDestroy {
  fromAirportCode: string;
  toAirportCode: string;
  selectedNavItem: string;
  @ViewChild('toggle') toggle;
  @ViewChild('navigationBookComponent')
  navigationBookComponent: NavigationBookComponent;

  isMobile = false;
  custId: any;
  mobileNav: boolean;
  fromAirport: any;
  toAirport: any;
  navigation = true;
  isEDPFlag: any;
  prefCity: any;
  recentSelected: RecentSearch;
  savedSelected: any;
  mkcpgn: string;
  partnerId = 'default';
  corpPartner: ICorporatePartner;
  businessAccountOptionsList = {};
  queryParam: BookParameters;
  @Input() airport;
  @Input() toAirportOd;
  airPortForOdPair;
  toAirportOdPair;
  unsubscribe = new Subject();
  canBookNonRefundable;
  isloggedIn = false;

  constructor(
    private cdf: ChangeDetectorRef,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    public cookieHelper: CookieHelper,
    private switchingAccountService: SwitchingAccountService,
    private accountSummaryService: AccountSummaryService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.businessAccountOptionsList =
      this.switchingAccountService.initializeViewData();
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (event && event.currentTarget) {
      if (event.currentTarget.innerWidth < 992) {
      } else {
        this.closeModal();
      }
    }
    this.cdf.detectChanges();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.accountSummaryService
        .getAccountSummaryDetails()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              if (data && data['smNumber']) {
                this.custId = data['smNumber'];
                this.canBookNonRefundable = data['canBookNonRefundable'];
                this.isloggedIn =
                  data['loggedIn'] || data['isWarmState'] || false;
              }
            }
          },
          (err) => {
            if (err) {
              console.error(err);
            }
          }
        );
    }

    const account = this.cookieHelper.getCookieValue('account');
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    const hipmunkCookie =
      this.cookieHelper.getCookieValue('isHipmunk') !== null
        ? this.cookieHelper.getCookieValue('isHipmunk')
        : false;
    this.airPortForOdPair = this.airport;
    this.toAirportOdPair = this.toAirportOd;
    if (account && account.length) {
      const parseAccount = JSON.parse(account);
      this.businessAccountOptionsList =
        parseAccount['businessAccountOptionsList'];
      this.partnerId = this.businessAccountOptionsList['partnerId'];
      this.cdf.detectChanges();
    } else if (hipmunkCookie === 'true' || hipmunkCookie) {
      this.partnerId = 'hipmunk';
    } else if (setPartnerToPersonal && setPartnerToPersonal.length) {
      this.partnerId = setPartnerToPersonal;
    } else {
      this.partnerId = 'default';
    }
    this.corpPartner = getCorporatePartner(this.partnerId);
  }

  public toggleContent(selectedItem) {
    if (this.selectedNavItem !== selectedItem) {
      if (selectedItem === '-1') {
        // this.selectedNavItem = 'book';
        // this.cdf.detectChanges();
      } else {
        this.selectedNavItem = selectedItem;
        this.cdf.detectChanges();
      }
    }
  }

  closeModal() {
    this.bsModalRef.hide();
    document.getElementsByTagName('body')[0].classList.remove('hamburger-open');
  }

  public onFromAirportSearched(fromAirport) {
    this.fromAirportCode = fromAirport;
  }

  public onToAirportSearched(toAirport) {
    this.toAirport = toAirport;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }
}
